import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import Dashboard from './components/Dashboard';
import Layout from './components/shared/Layout';
import Login from './components/Login'
import UploadStdFiles from './components/mvp/UploadStdFiles'
import UploadQcFiles from './components/mvp/UploadQcFiles';
import UploadUnkFiles from './components/mvp/UploadUnkFiles';
import StartConfig from './components/mvp/StartConfig';
import PeaksApproval from './components/mvp/PeaksApproval';
import SplashScreen from './components/shared/SplashScreen';
import CalibrationCurve from './components/mvp/CalibrationCurve';
import PeaksOnQc from './components/mvp/PeaksOnQc';
import ShowAllFiles from './components/mvp/ShowAllFiles';
import Qa from './components/mvp/Qa';
import ProtectedRoute from './components/ProtectedRoute';
import { useAuthInit } from './hooks/useAuthInit';
import SuperAdminDashboard from './components/SuperAdminDashboard';
import AppInitializer from './components/shared/AppInitializer'; // ⬅️ new import
import { useSelector } from 'react-redux';

function App() {
  const authChecked = useAuthInit();
  const hydrated = useSelector((state) => state.auth.hydrated);

  // Route object tree for data router
  const router = createBrowserRouter([
    {
      path: '/',
      element: (
        <ProtectedRoute allowedRoles={['super_admin', 'admin', 'user']}>
          <Layout />
        </ProtectedRoute>
      ),
      children: [
        { index: true, element: <Dashboard /> },
        { path: 'superAdminDashboard', element: <SuperAdminDashboard /> },
        { path: 'configuration', element: <StartConfig /> },
        { path: 'configuration/uploadStdFiles', element: <UploadStdFiles /> },
        { path: 'configuration/uploadQcFiles', element: <UploadQcFiles /> },
        { path: 'configuration/uploadUnkFiles', element: <UploadUnkFiles /> },
        { path: 'configuration/peaksApproval', element: <PeaksApproval /> },
        { path: 'configuration/calibrationCurve', element: <CalibrationCurve /> },
        { path: 'configuration/peaksOnQc', element: <PeaksOnQc /> },
        { path: 'configuration/showAllFiles', element: <ShowAllFiles /> },
        { path: 'configuration/qa', element: <Qa /> },
      ],
    },
    { path: 'login', element: <Login /> },
  ]);

  return (
    <>
      <AppInitializer />
      {/* 🔒 Show splash while auth is checking or hydration hasn't completed */}
      {(!authChecked || !hydrated) ? (
        <SplashScreen />
      ) : (
        <RouterProvider router={router} />
      )}
    </>
  );
}

export default App;
